<template>
  <div class='mb25 s_flex_ali'>
    <span class='mr15'>
      <a-button type="primary" v-has:wxCodeCateAdd="()=>editType('add')">
        <PlusOutlined />
        添加分类
      </a-button>
    </span>
  </div>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
    <template v-slot:action="{ record }">
      <a class="m-r-15" v-has:wxCodeCateEdit="()=>editType(record)" href="javascript:;">修改</a>
      <a v-has:wxCodeCateDel="()=>delType(record)" href="javascript:;">删除</a>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />

  <a-modal  :keyboard="false" :title="type=='edit'?'编辑分类':'添加分类'" :width='500' centered :footer="null" v-model:visible="visible"
    @ok="handleOk" destroyOnClose>
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item ref="name" label="分类名称" name="name" help='限8个字符'>
        <a-input v-model:value="form.name" placeholder='请输入分类名称' />
      </a-form-item>
      <a-form-item ref="sort" label="排序" name="sort" help='0-9999'>
        <a-input v-model:value="form.sort" placeholder='请输入排序' />
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 4, offset: 4 }">
        <a-button type="primary" @click="onSubmit">
          保存
        </a-button>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
  import {  PlusOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getRouter } from "@/utils/app";
  import { setPageState, getPageState } from "@/utils/pageState";
  import { getwx_qrcode_cate, wx_qrcode_cateDel, wx_qrcode_cateAdd, wx_qrcode_cateEdit } from "@/api/public_wx";
  import { iscode } from "@/utils/app";
  // 初始化默认筛选项数值
  let defForm = {
    name: '',
    sort: ''
  }
  let defSearch = {
    page: 1,
    limit: 10
  };
  export default {
    components: {  PlusOutlined },
    name: 'typeList',
    setup(props, ctx) {
      // 列表数据和列头配置
      let data = ref([]);
      const form = ref({ ...defForm });
      const search = ref({ ...defSearch });
      const state = reactive({
        visible: false,
        listLoading: false,
        type: 'add',
        total: 1,
        edit: false,
        labelCol: { span: 4 },
        wrapperCol: { span: 16 },
        rules: {
          name: [
            { required: true, message: '请输入分类名称', trigger: 'blur' }
          ],
        }
      });
      let columns = [
        {
          title: "分类名称",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "显示顺序",
          dataIndex: "sort",
          key: "sort",
          width:150,
        },
        {
          title: "操作",
          key: "action",
          width:150,
          slots: { customRender: "action" },
        },
      ];
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      //删除分类
      const delType = (e) => {
        $Modal.confirm({
          centered: true,
          title: '删除分类',
          content: '删除后该分类将无法恢复，您确定要删除该分类吗？', onOk: async () => {
            let res = await wx_qrcode_cateDel({ id: e.id }).then(res => res.data);
            if (iscode(res)) {
              message.success(res.msg);
              initData(search.value);
            } else {
              message.error(res.msg);
            }
          }
        })
      }
      // 修改
      const editType = (e) => {
        if(e == 'add'){
          form.value = {name: '',sort: ''}
          state.visible = true
          state.type = 'add'
        }else{
          form.value = e
          state.visible = true
          state.type = 'edit'
        }
      }
      const ruleForm = ref()
      const onSubmit = () => {
        ruleForm.value.validate().then(async () => {
          let res
          const hide = message.loading('正在加载中...', 0);
          if (state.type == 'add') {
            res = await wx_qrcode_cateAdd(form.value).then(res => res.data);
          } else {
            res = await wx_qrcode_cateEdit(form.value).then(res => res.data);
          }
          if (iscode(res)) {
            setTimeout(hide);
            message.success(res.msg);
            setTimeout(() => {
              state.visible = false
              initData(search.value)
              state.type = 'add'
              ruleForm.value.resetFields()
            }, 1000);
          } else {
            setTimeout(hide);
            message.error(res.msg);
          }
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getwx_qrcode_cate(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data.data;
            state.total = res.data.total;
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };


      onMounted(() => {
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        form,
        data,
        columns,
        pageCurrentChange,
        pageSizeChange,
        delType,
        editType,
        ruleForm,
        onSubmit
      };
    },
  };
</script>